import { AnimatedCubeIcon } from '@/components/animated/animated-cube-icon';
import { LayoutTextFlip } from '@/components/animated/layout-text-flip';

export function HomePage() {
  return (
    <main className="w-full min-h-[calc(100vh-8rem)] flex flex-col items-center justify-center p-24 gap-12">
      <div className="py-4">
        <AnimatedCubeIcon size={60} />
      </div>
      <p className="text-2xl font-semibold">Bem vindo ao BCube!</p>

      <div className="w-full flex flex-col gap-4 items-center justify-center">
        <LayoutTextFlip
          text="Controle de:"
          words={['Estoque', 'Produtos', 'Usuários', 'Contas', 'Propostas']}
        />
      </div>

      <p className="text-sm text-gray-500/60">Desenvolvido pelo time BWS Soft.</p>
    </main>
  );
}
